import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Downtime, Feature, Limit } from './state';

export const loadFeatureFlagsAndLimits = createAction(
  '[Feature Flags and Limits] Load Feature Flags and Limits '
);

export const loadFeatureFlagsAndLimitsSuccess = createAction(
  '[Feature Flags and Limits] Load Feature Flags and Limits Success',
  props<{ features: Feature[], limits: Limit[], downtime: Downtime }>()
);

export const loadFeatureFlagsAndLimitsFailure = createAction(
  '[Feature Flags and Limits] Load Feature Flags and Limits Failure',
  props<{ error: HttpErrorResponse }>(),
);
